<template>
    <translates
        :item="this.modif"
        :item_id="parseInt(modif.id)"
        item_type="modifier">
    </translates>
</template>

<script>
import translates from "../../../../translates/translates";

export default {
    name: "m_translate",
    components: {
        translates
    },
    props : {
        modif : {
            type : Object
        }
    },
}
</script>

<style scoped>

</style>
